// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning_modal_wrapper {
  background: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 100;
}
.warning_modal {
  width: 100%;
  max-width: 500px;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}
.text_1 {
  color: red;
  font-weight: 600;
}
.warning_modal_wrapper button {
  padding: 7px 20px;
  background: #0c1066;
  border: 1.5px solid #0c1066;
  color: white;
  border-radius: 5px;
  font-weight: 500;
  text-transform: uppercase;
}
.warning_modal_wrapper button:hover {
  background: transparent;
  color: #0c1066;
}
`, "",{"version":3,"sources":["webpack://./src/components/WarningModal/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB;;uEAEqE;AACvE;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".warning_modal_wrapper {\r\n  background: #fafafa;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 100;\r\n}\r\n.warning_modal {\r\n  width: 100%;\r\n  max-width: 500px;\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,\r\n    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,\r\n    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n}\r\n.text_1 {\r\n  color: red;\r\n  font-weight: 600;\r\n}\r\n.warning_modal_wrapper button {\r\n  padding: 7px 20px;\r\n  background: #0c1066;\r\n  border: 1.5px solid #0c1066;\r\n  color: white;\r\n  border-radius: 5px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n}\r\n.warning_modal_wrapper button:hover {\r\n  background: transparent;\r\n  color: #0c1066;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
